module.exports = __webpack_public_path__ + "img/category_instagrammable_places.d2d5a54.png";